export const COUNTRY_TIMEZONES = {
  AD: { timezone: 'Europe/Andorra', alpha3: 'AND', callingCode: '376' },
  AE: { timezone: 'Asia/Dubai', alpha3: 'ARE', callingCode: '971' },
  AF: { timezone: 'Asia/Kabul', alpha3: 'AFG', callingCode: '93' },
  AG: { timezone: 'America/Antigua', alpha3: 'ATG', callingCode: '1268' },
  AI: { timezone: 'America/Anguilla', alpha3: 'AIA', callingCode: '1264' },
  AL: { timezone: 'Europe/Tirane', alpha3: 'ALB', callingCode: '355' },
  AM: { timezone: 'Asia/Yerevan', alpha3: 'ARM', callingCode: '374' },
  AO: { timezone: 'Africa/Lagos', alpha3: 'AGO', callingCode: '244' },
  AQ: { timezone: 'Antarctica/Casey', alpha3: 'ATA', callingCode: '' },
  AR: { timezone: 'America/Argentina/Buenos_Aires', alpha3: 'ARG', callingCode: '54' },
  AS: { timezone: 'Pacific/Pago_Pago', alpha3: 'ASM', callingCode: '1684' },
  AT: { timezone: 'Europe/Vienna', alpha3: 'AUT', callingCode: '43' },
  AU: { timezone: 'Australia/Sydney', alpha3: 'AUS', callingCode: '61' },
  AW: { timezone: 'America/Aruba', alpha3: 'ABW', callingCode: '297' },
  AX: { timezone: 'Europe/Helsinki', alpha3: 'ALA', callingCode: '' },
  AZ: { timezone: 'Asia/Baku', alpha3: 'AZE', callingCode: '994' },
  BA: { timezone: 'Europe/Belgrade', alpha3: 'BIH', callingCode: '387' },
  BB: { timezone: 'America/Barbados', alpha3: 'BRB', callingCode: '1246' },
  BD: { timezone: 'Asia/Dhaka', alpha3: 'BGD', callingCode: '880' },
  BE: { timezone: 'Europe/Brussels', alpha3: 'BEL', callingCode: '32' },
  BF: { timezone: 'Africa/Abidjan', alpha3: 'BFA', callingCode: '226' },
  BG: { timezone: 'Europe/Sofia', alpha3: 'BGR', callingCode: '359' },
  BH: { timezone: 'Asia/Qatar', alpha3: 'BHR', callingCode: '973' },
  BI: { timezone: 'Africa/Maputo', alpha3: 'BDI', callingCode: '257' },
  BJ: { timezone: 'Africa/Lagos', alpha3: 'BEN', callingCode: '229' },
  BL: { timezone: 'America/St_Barthelemy', alpha3: 'BLM', callingCode: '' },
  BM: { timezone: 'Atlantic/Bermuda', alpha3: 'BMU', callingCode: '1441' },
  BN: { timezone: 'Asia/Kuching', alpha3: 'BRN', callingCode: '673' },
  BO: { timezone: 'America/La_Paz', alpha3: 'BOL', callingCode: '591' },
  BQ: { timezone: 'America/Kralendijk', alpha3: 'BES', callingCode: '' },
  BR: { timezone: 'America/Sao_Paulo', alpha3: 'BRA', callingCode: '55' },
  BS: { timezone: 'America/Toronto', alpha3: 'BHS', callingCode: '1242' },
  BT: { timezone: 'Asia/Thimphu', alpha3: 'BTN', callingCode: '975' },
  BW: { timezone: 'Africa/Maputo', alpha3: 'BWA', callingCode: '267' },
  BY: { timezone: 'Europe/Minsk', alpha3: 'BLR', callingCode: '375' },
  BZ: { timezone: 'America/Belize', alpha3: 'BLZ', callingCode: '501' },
  CA: {
    timezone: 'America/Toronto',
    alpha3: 'CAN',
    // since CANADA and USA both have 1 as calling code, we need to check the area code also
    callingCode: [
      '1204',
      '1226',
      '1236',
      '1249',
      '1250',
      '1257',
      '1263',
      '1273',
      '1289',
      '1306',
      '1343',
      '1354',
      '1365',
      '1367',
      '1368',
      '1382',
      '1387',
      '1403',
      '1416',
      '1418',
      '1421',
      '1428',
      '1431',
      '1437',
      '1438',
      '1450',
      '1468',
      '1474',
      '1506',
      '1514',
      '1519',
      '1548',
      '1579',
      '1581',
      '1584',
      '1587',
      '1600',
      '1604',
      '1613',
      '1639',
      '1647',
      '1672',
      '1683',
      '1705',
      '1709',
      '1742',
      '1753',
      '1778',
      '1780',
      '1782',
      '1807',
      '1819',
      '1825',
      '1867',
      '1873',
      '1879',
      '1902',
      '1905',
      '1942',
    ],
  },
  CC: { timezone: 'Asia/Yangon', alpha3: 'CCK', callingCode: '' },
  CD: { timezone: 'Africa/Kinshasa', alpha3: 'COD', callingCode: '243' },
  CF: { timezone: 'Africa/Lagos', alpha3: 'CAF', callingCode: '236' },
  CG: { timezone: 'Africa/Lagos', alpha3: 'COG', callingCode: '242' },
  CH: { timezone: 'Europe/Zurich', alpha3: 'CHE', callingCode: '41' },
  CI: { timezone: 'Africa/Abidjan', alpha3: 'CIV', callingCode: '225' },
  CK: { timezone: 'Pacific/Rarotonga', alpha3: 'COK', callingCode: '682' },
  CL: { timezone: 'America/Santiago', alpha3: 'CHL', callingCode: '56' },
  CM: { timezone: 'Africa/Lagos', alpha3: 'CMR', callingCode: '237' },
  CN: { timezone: 'Asia/Shanghai', alpha3: 'CHN', callingCode: '86' },
  CO: { timezone: 'America/Bogota', alpha3: 'COL', callingCode: '57' },
  CR: { timezone: 'America/Costa_Rica', alpha3: 'CRI', callingCode: '506' },
  CU: { timezone: 'America/Havana', alpha3: 'CUB', callingCode: '53' },
  CV: { timezone: 'Atlantic/Cape_Verde', alpha3: 'CPV', callingCode: '238' },
  CW: { timezone: 'America/Curacao', alpha3: 'CUW', callingCode: '599' },
  CX: { timezone: 'Asia/Bangkok', alpha3: 'CXR', callingCode: '' },
  CY: { timezone: 'Asia/Nicosia', alpha3: 'CYP', callingCode: '357' },
  CZ: { timezone: 'Europe/Prague', alpha3: 'CZE', callingCode: '420' },
  DE: { timezone: 'Europe/Berlin', alpha3: 'DEU', callingCode: '49' },
  DJ: { timezone: 'Africa/Nairobi', alpha3: 'DJI', callingCode: '253' },
  DK: { timezone: 'Europe/Berlin', alpha3: 'DNK', callingCode: '45' },
  DM: { timezone: 'America/Dominica', alpha3: 'DMA', callingCode: '1767' },
  DO: { timezone: 'America/Santo_Domingo', alpha3: 'DOM', callingCode: '1809' },
  DZ: { timezone: 'Africa/Algiers', alpha3: 'DZA', callingCode: '213' },
  EC: { timezone: 'America/Guayaquil', alpha3: 'ECU', callingCode: '593' },
  EE: { timezone: 'Europe/Tallinn', alpha3: 'EST', callingCode: '372' },
  EG: { timezone: 'Africa/Cairo', alpha3: 'EGY', callingCode: '20' },
  EH: { timezone: 'Africa/El_Aaiun', alpha3: 'ESH', callingCode: '' },
  ER: { timezone: 'Africa/Nairobi', alpha3: 'ERI', callingCode: '291' },
  ES: { timezone: 'Europe/Madrid', alpha3: 'ESP', callingCode: '34' },
  ET: { timezone: 'Africa/Nairobi', alpha3: 'ETH', callingCode: '251' },
  FI: { timezone: 'Europe/Helsinki', alpha3: 'FIN', callingCode: '358' },
  FJ: { timezone: 'Pacific/Fiji', alpha3: 'FJI', callingCode: '679' },
  FK: { timezone: 'Atlantic/Stanley', alpha3: 'FLK', callingCode: '' },
  FM: { timezone: 'Pacific/Pohnpei', alpha3: 'FSM', callingCode: '691' },
  FO: { timezone: 'Atlantic/Faroe', alpha3: 'FRO', callingCode: '298' },
  FR: { timezone: 'Europe/Paris', alpha3: 'FRA', callingCode: '33' },
  GA: { timezone: 'Africa/Lagos', alpha3: 'GAB', callingCode: '241' },
  GB: { timezone: 'Europe/London', alpha3: 'GBR', callingCode: '44' },
  GD: { timezone: 'America/Grenada', alpha3: 'GRD', callingCode: '1473' },
  GE: { timezone: 'Asia/Tbilisi', alpha3: 'GEO', callingCode: '995' },
  GF: { timezone: 'America/Cayenne', alpha3: 'GUF', callingCode: '594' },
  GG: { timezone: 'Europe/London', alpha3: 'GGY', callingCode: '' },
  GH: { timezone: 'Africa/Abidjan', alpha3: 'GHA', callingCode: '233' },
  GI: { timezone: 'Europe/Gibraltar', alpha3: 'GIB', callingCode: '350' },
  GL: { timezone: 'America/Nuuk', alpha3: 'GRL', callingCode: '299' },
  GM: { timezone: 'Africa/Abidjan', alpha3: 'GMB', callingCode: '220' },
  GN: { timezone: 'Africa/Abidjan', alpha3: 'GIN', callingCode: '224' },
  GP: { timezone: 'America/Guadeloupe', alpha3: 'GLP', callingCode: '590' },
  GQ: { timezone: 'Africa/Lagos', alpha3: 'GNQ', callingCode: '240' },
  GR: { timezone: 'Europe/Athens', alpha3: 'GRC', callingCode: '30' },
  GS: { timezone: 'Atlantic/South_Georgia', alpha3: 'SGS', callingCode: '' },
  GT: { timezone: 'America/Guatemala', alpha3: 'GTM', callingCode: '502' },
  GU: { timezone: 'Pacific/Guam', alpha3: 'GUM', callingCode: '1671' },
  GW: { timezone: 'Africa/Bissau', alpha3: 'GNB', callingCode: '245' },
  GY: { timezone: 'America/Guyana', alpha3: 'GUY', callingCode: '592' },
  HK: { timezone: 'Asia/Hong_Kong', alpha3: 'HKG', callingCode: '852' },
  HN: { timezone: 'America/Tegucigalpa', alpha3: 'HND', callingCode: '504' },
  HR: { timezone: 'Europe/Belgrade', alpha3: 'HRV', callingCode: '385' },
  HT: { timezone: 'America/Port-au-Prince', alpha3: 'HTI', callingCode: '509' },
  HU: { timezone: 'Europe/Budapest', alpha3: 'HUN', callingCode: '36' },
  ID: { timezone: 'Asia/Jakarta', alpha3: 'IDN', callingCode: '62' },
  IE: { timezone: 'Europe/Dublin', alpha3: 'IRL', callingCode: '353' },
  IL: { timezone: 'Asia/Jerusalem', alpha3: 'ISR', callingCode: '972' },
  IM: { timezone: 'Europe/London', alpha3: 'IMN', callingCode: '' },
  IN: { timezone: 'Asia/Kolkata', alpha3: 'IND', callingCode: '91' },
  IO: { timezone: 'Indian/Chagos', alpha3: 'IOT', callingCode: '246' },
  IQ: { timezone: 'Asia/Baghdad', alpha3: 'IRQ', callingCode: '964' },
  IR: { timezone: 'Asia/Tehran', alpha3: 'IRN', callingCode: '98' },
  IS: { timezone: 'Africa/Abidjan', alpha3: 'ISL', callingCode: '354' },
  IT: { timezone: 'Europe/Rome', alpha3: 'ITA', callingCode: '39' },
  JE: { timezone: 'Europe/London', alpha3: 'JEY', callingCode: '' },
  JM: { timezone: 'America/Jamaica', alpha3: 'JAM', callingCode: '1876' },
  JO: { timezone: 'Asia/Amman', alpha3: 'JOR', callingCode: '962' },
  JP: { timezone: 'Asia/Tokyo', alpha3: 'JPN', callingCode: '81' },
  KE: { timezone: 'Africa/Nairobi', alpha3: 'KEN', callingCode: '254' },
  KG: { timezone: 'Asia/Bishkek', alpha3: 'KGZ', callingCode: '996' },
  KH: { timezone: 'Asia/Bangkok', alpha3: 'KHM', callingCode: '855' },
  KI: { timezone: 'Pacific/Tarawa', alpha3: 'KIR', callingCode: '686' },
  KM: { timezone: 'Africa/Nairobi', alpha3: 'COM', callingCode: '269' },
  KN: { timezone: 'America/St_Kitts', alpha3: 'KNA', callingCode: '1869' },
  KP: { timezone: 'Asia/Pyongyang', alpha3: 'PRK', callingCode: '850' },
  KR: { timezone: 'Asia/Seoul', alpha3: 'KOR', callingCode: '82' },
  KW: { timezone: 'Asia/Riyadh', alpha3: 'KWT', callingCode: '965' },
  KY: { timezone: 'America/Cayman', alpha3: 'CYM', callingCode: '1345' },
  KZ: { timezone: 'Asia/Almaty', alpha3: 'KAZ', callingCode: '' },
  LA: { timezone: 'Asia/Bangkok', alpha3: 'LAO', callingCode: '856' },
  LB: { timezone: 'Asia/Beirut', alpha3: 'LBN', callingCode: '961' },
  LC: { timezone: 'America/St_Lucia', alpha3: 'LCA', callingCode: '1758' },
  LI: { timezone: 'Europe/Zurich', alpha3: 'LIE', callingCode: '423' },
  LK: { timezone: 'Asia/Colombo', alpha3: 'LKA', callingCode: '94' },
  LR: { timezone: 'Africa/Monrovia', alpha3: 'LBR', callingCode: '231' },
  LS: { timezone: 'Africa/Johannesburg', alpha3: 'LSO', callingCode: '266' },
  LT: { timezone: 'Europe/Vilnius', alpha3: 'LTU', callingCode: '370' },
  LU: { timezone: 'Europe/Brussels', alpha3: 'LUX', callingCode: '352' },
  LV: { timezone: 'Europe/Riga', alpha3: 'LVA', callingCode: '' },
  LY: { timezone: 'Africa/Tripoli', alpha3: 'LBY', callingCode: '218' },
  MA: { timezone: 'Africa/Casablanca', alpha3: 'MAR', callingCode: '212' },
  MC: { timezone: 'Europe/Paris', alpha3: 'MCO', callingCode: '377' },
  MD: { timezone: 'Europe/Chisinau', alpha3: 'MDA', callingCode: '373' },
  ME: { timezone: 'Europe/Belgrade', alpha3: 'MNE', callingCode: '382' },
  MF: { timezone: 'America/Marigot', alpha3: 'MAF', callingCode: '' },
  MG: { timezone: 'Africa/Nairobi', alpha3: 'MDG', callingCode: '261' },
  MH: { timezone: 'Pacific/Kwajalein', alpha3: 'MHL', callingCode: '692' },
  MK: { timezone: 'Europe/Belgrade', alpha3: 'MKD', callingCode: '389' },
  ML: { timezone: 'Africa/Abidjan', alpha3: 'MLI', callingCode: '223' },
  MM: { timezone: 'Asia/Yangon', alpha3: 'MMR', callingCode: '95' },
  MN: { timezone: 'Asia/Ulaanbaatar', alpha3: 'MNG', callingCode: '976' },
  MO: { timezone: 'Asia/Macau', alpha3: 'MAC', callingCode: '853' },
  MP: { timezone: 'Pacific/Guam', alpha3: 'MNP', callingCode: '1670' },
  MQ: { timezone: 'America/Martinique', alpha3: 'MTQ', callingCode: '596' },
  MR: { timezone: 'Africa/Abidjan', alpha3: 'MRT', callingCode: '222' },
  MS: { timezone: 'America/Montserrat', alpha3: 'MSR', callingCode: '1664' },
  MT: { timezone: 'Europe/Malta', alpha3: 'MLT', callingCode: '356' },
  MU: { timezone: 'Indian/Mauritius', alpha3: 'MUS', callingCode: '230' },
  MV: { timezone: 'Indian/Maldives', alpha3: 'MDV', callingCode: '960' },
  MW: { timezone: 'Africa/Maputo', alpha3: 'MWI', callingCode: '265' },
  MX: { timezone: 'America/Mexico_City', alpha3: 'MEX', callingCode: '52' },
  MY: { timezone: 'Asia/Kuching', alpha3: 'MYS', callingCode: '60' },
  MZ: { timezone: 'Africa/Maputo', alpha3: 'MOZ', callingCode: '258' },
  NA: { timezone: 'Africa/Windhoek', alpha3: 'NAM', callingCode: '264' },
  NC: { timezone: 'Pacific/Noumea', alpha3: 'NCL', callingCode: '687' },
  NE: { timezone: 'Africa/Lagos', alpha3: 'NER', callingCode: '227' },
  NF: { timezone: 'Pacific/Norfolk', alpha3: 'NFK', callingCode: '' },
  NG: { timezone: 'Africa/Lagos', alpha3: 'NGA', callingCode: '234' },
  NI: { timezone: 'America/Managua', alpha3: 'NIC', callingCode: '505' },
  NL: { timezone: 'Europe/Brussels', alpha3: 'NLD', callingCode: '31' },
  NO: { timezone: 'Europe/Berlin', alpha3: 'NOR', callingCode: '47' },
  NP: { timezone: 'Asia/Kathmandu', alpha3: 'NPL', callingCode: '977' },
  NR: { timezone: 'Pacific/Nauru', alpha3: 'NRU', callingCode: '674' },
  NU: { timezone: 'Pacific/Niue', alpha3: 'NIU', callingCode: '683' },
  NZ: { timezone: 'Pacific/Auckland', alpha3: 'NZL', callingCode: '64' },
  OM: { timezone: 'Asia/Dubai', alpha3: 'OMN', callingCode: '968' },
  PA: { timezone: 'America/Panama', alpha3: 'PAN', callingCode: '507' },
  PE: { timezone: 'America/Lima', alpha3: 'PER', callingCode: '51' },
  PF: { timezone: 'Pacific/Tahiti', alpha3: 'PYF', callingCode: '689' },
  PG: { timezone: 'Pacific/Port_Moresby', alpha3: 'PNG', callingCode: '675' },
  PH: { timezone: 'Asia/Manila', alpha3: 'PHL', callingCode: '63' },
  PK: { timezone: 'Asia/Karachi', alpha3: 'PAK', callingCode: '92' },
  PL: { timezone: 'Europe/Warsaw', alpha3: 'POL', callingCode: '48' },
  PM: { timezone: 'America/Miquelon', alpha3: 'SPM', callingCode: '508' },
  PN: { timezone: 'Pacific/Pitcairn', alpha3: 'PCN', callingCode: '' },
  PR: { timezone: 'America/Puerto_Rico', alpha3: 'PRI', callingCode: '1787' },
  PS: { timezone: 'Asia/Hebron', alpha3: 'PSE', callingCode: '970' },
  PT: { timezone: 'Europe/Lisbon', alpha3: 'PRT', callingCode: '351' },
  PW: { timezone: 'Pacific/Palau', alpha3: 'PLW', callingCode: '680' },
  PY: { timezone: 'America/Asuncion', alpha3: 'PRY', callingCode: '595' },
  QA: { timezone: 'Asia/Qatar', alpha3: 'QAT', callingCode: '974' },
  RE: { timezone: 'Indian/Reunion', alpha3: 'REU', callingCode: '262' },
  RO: { timezone: 'Europe/Bucharest', alpha3: 'ROU', callingCode: '40' },
  RS: { timezone: 'Europe/Belgrade', alpha3: 'SRB', callingCode: '381' },
  RU: { timezone: 'Europe/Moscow', alpha3: 'RUS', callingCode: '7' },
  RW: { timezone: 'Africa/Maputo', alpha3: 'RWA', callingCode: '250' },
  SA: { timezone: 'Asia/Riyadh', alpha3: 'SAU', callingCode: '966' },
  SB: { timezone: 'Pacific/Guadalcanal', alpha3: 'SLB', callingCode: '677' },
  SC: { timezone: 'Indian/Mahe', alpha3: 'SYC', callingCode: '248' },
  SD: { timezone: 'Africa/Khartoum', alpha3: 'SDN', callingCode: '249' },
  SE: { timezone: 'Europe/Berlin', alpha3: 'SWE', callingCode: '46' },
  SG: { timezone: 'Asia/Singapore', alpha3: 'SGP', callingCode: '65' },
  SH: { timezone: 'Africa/Abidjan', alpha3: 'SHN', callingCode: '290' },
  SI: { timezone: 'Europe/Belgrade', alpha3: 'SVN', callingCode: '386' },
  SJ: { timezone: 'Europe/Berlin', alpha3: 'SJM', callingCode: '' },
  SK: { timezone: 'Europe/Prague', alpha3: 'SVK', callingCode: '421' },
  SL: { timezone: 'Africa/Abidjan', alpha3: 'SLE', callingCode: '232' },
  SM: { timezone: 'Europe/Rome', alpha3: 'SMR', callingCode: '378' },
  SN: { timezone: 'Africa/Abidjan', alpha3: 'SEN', callingCode: '221' },
  SO: { timezone: 'Africa/Nairobi', alpha3: 'SOM', callingCode: '252' },
  SR: { timezone: 'America/Paramaribo', alpha3: 'SUR', callingCode: '597' },
  SS: { timezone: 'Africa/Juba', alpha3: 'SSD', callingCode: '211' },
  ST: { timezone: 'Africa/Sao_Tome', alpha3: 'STP', callingCode: '239' },
  SV: { timezone: 'America/El_Salvador', alpha3: 'SLV', callingCode: '503' },
  SX: { timezone: 'America/Lower_Princes', alpha3: 'SXM', callingCode: '1721' },
  SY: { timezone: 'Asia/Damascus', alpha3: 'SYR', callingCode: '963' },
  SZ: { timezone: 'Africa/Johannesburg', alpha3: 'SWZ', callingCode: '268' },
  TC: { timezone: 'America/Grand_Turk', alpha3: 'TCA', callingCode: '1649' },
  TD: { timezone: 'Africa/Ndjamena', alpha3: 'TCD', callingCode: '235' },
  TF: { timezone: 'Indian/Kerguelen', alpha3: 'ATF', callingCode: '' },
  TG: { timezone: 'Africa/Abidjan', alpha3: 'TGO', callingCode: '228' },
  TH: { timezone: 'Asia/Bangkok', alpha3: 'THA', callingCode: '66' },
  TJ: { timezone: 'Asia/Dushanbe', alpha3: 'TJK', callingCode: '992' },
  TK: { timezone: 'Pacific/Fakaofo', alpha3: 'TKL', callingCode: '690' },
  TL: { timezone: 'Asia/Dili', alpha3: 'TLS', callingCode: '670' },
  TM: { timezone: 'Asia/Ashgabat', alpha3: 'TKM', callingCode: '993' },
  TN: { timezone: 'Africa/Tunis', alpha3: 'TUN', callingCode: '216' },
  TO: { timezone: 'Pacific/Tongatapu', alpha3: 'TON', callingCode: '676' },
  TR: { timezone: 'Europe/Istanbul', alpha3: 'TUR', callingCode: '90' },
  TT: { timezone: 'America/Port_of_Spain', alpha3: 'TTO', callingCode: '1868' },
  TV: { timezone: 'Pacific/Tarawa', alpha3: 'TUV', callingCode: '688' },
  TW: { timezone: 'Asia/Taipei', alpha3: 'TWN', callingCode: '886' },
  TZ: { timezone: 'Africa/Nairobi', alpha3: 'TZA', callingCode: '255' },
  UA: { timezone: 'Europe/Kyiv', alpha3: 'UKR', callingCode: '380' },
  UG: { timezone: 'Africa/Nairobi', alpha3: 'UGA', callingCode: '256' },
  UM: { timezone: 'Pacific/Pago_Pago', alpha3: 'UMI', callingCode: '' },
  US: { timezone: 'America/New_York', alpha3: 'USA', callingCode: '1' },
  UY: { timezone: 'America/Montevideo', alpha3: 'URY', callingCode: '598' },
  UZ: { timezone: 'Asia/Tashkent', alpha3: 'UZB', callingCode: '998' },
  VA: { timezone: 'Europe/Rome', alpha3: 'VAT', callingCode: '379' },
  VC: { timezone: 'America/St_Vincent', alpha3: 'VCT', callingCode: '1784' },
  VE: { timezone: 'America/Caracas', alpha3: 'VEN', callingCode: '58' },
  VG: { timezone: 'America/Tortola', alpha3: 'VGB', callingCode: '1284' },
  VI: { timezone: 'America/St_Thomas', alpha3: 'VIR', callingCode: '1340' },
  VN: { timezone: 'Asia/Ho_Chi_Minh', alpha3: 'VNM', callingCode: '84' },
  VU: { timezone: 'Pacific/Efate', alpha3: 'VUT', callingCode: '678' },
  WF: { timezone: 'Pacific/Tarawa', alpha3: 'WLF', callingCode: '681' },
  WS: { timezone: 'Pacific/Apia', alpha3: 'WSM', callingCode: '685' },
  YE: { timezone: 'Asia/Riyadh', alpha3: 'YEM', callingCode: '967' },
  YT: { timezone: 'Africa/Nairobi', alpha3: 'MYT', callingCode: '' },
  ZA: { timezone: 'Africa/Johannesburg', alpha3: 'ZAF', callingCode: '27' },
  ZM: { timezone: 'Africa/Maputo', alpha3: 'ZMB', callingCode: '260' },
  ZW: { timezone: 'Africa/Maputo', alpha3: 'ZWE', callingCode: '263' },
};
